import { Component } from '@angular/core';

@Component({
  selector: 'app-close-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './close-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class CloseIconComponent {}
